module.exports = __webpack_public_path__ + "fonts/Archivo-Regular.ee3dc5e9.ttf";